(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "KarcherAlarmSubscriptionsController",
      KarcherAlarmSubscriptionsController
    );

  /** @ngInject */
  function KarcherAlarmSubscriptionsController(
    $scope,
    KarcherSubscriptionsAlarmsViewModel,
    messageActions,
    layoutActions,
    $mdDialog,
    dashboardKarcherActions
  ) {
    var vm = this;

    vm.alarmSubscriptions = new KarcherSubscriptionsAlarmsViewModel();
    /* eslint-disable */
    vm.addNewSubscription = function (ev) {
      $mdDialog
        .show({
          controller: CreateNewSubscriptionController,
          controllerAs: "vm",
          templateUrl:
            "app/alarmsKarcher/alarmSubscriptions/createSubscriptionDialog/createSubscription.html",
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false
        })
        .then(function () {});
    };

    vm.openMenu = function ($mdMenu, ev) {
      $mdMenu(ev);
    };

    vm.unsubscribeAlarm = function (id) {
      messageActions.unsubscribeKarcherAlert(id).then(function () {
        refresh();
      });
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on("destroy", function () {});
      refresh();
    }

    function refresh() {
      messageActions.getKarcherAlarmSubscriptions().then(function (response) {
        vm.alarmSubscriptions.refreshSubscriptionsList(response);
        layoutActions.hideLoader();
      });
    }

    function CreateNewSubscriptionController(organizationActions) {
      var that = this;
      that.selectedSite = {};
      that.lowAlarm = false;
      that.mediumAlarm = false;
      that.highAlarm = false;
      that.deviceListForSelectedSite = [];
      that.selectedDevice = null;
      that.faultListForSelectedDevice = [];
      that.faultCode = "";
      that.validateMultiplyItem = false;

      that.closeSubscribeDialog = function () {
        $mdDialog.hide();
      };

      that.onSelectSite = function () {
        dashboardKarcherActions
          .getKarcherSiteDetailsById(that.selectedSite.id)
          .then(function (response) {
            that.deviceListForSelectedSite = response;
          });
      };

      that.onSelectDevice = function () {
        dashboardKarcherActions
          .getKarcherFaultsByDeviceId(that.selectedDevice)
          .then(function (response) {
            that.faultListForSelectedDevice = response.map(function (fault) {
              return {
                id: fault.code,
                name: fault.name
              };
            });
          });
      };

      that.getFault = function (id) {
        that.lowAlarm = false;
        that.mediumAlarm = false;
        that.highAlarm = false;
        that.faultCode = id;
      };

      that.clearFaultInput = function () {
        that.faultCode = "";
      };

      that.clearDeviceInput = function () {
        that.selectedDevice = null;
        that.faultListForSelectedDevice = [];
        that.faultCode = "";
      };

      that.validateMultiplyItemsInput = function (validCheck) {
        that.validateMultiplyItem = validCheck;
      };

      that.onSelectCheckBox = function () {
        that.validateMultiplyItem =
          !that.lowAlarm && !that.mediumAlarm && !that.highAlarm;
      };

      that.subscribeData = function () {
        layoutActions.showLoader();
        var dataToSave = {
          sitePointId: that.selectedSite.id,
          deviceId: that.selectedDevice,
          faultNumber: that.faultCode === "" ? null : that.faultCode,
          siteName: that.selectedSite.name,
          low: that.lowAlarm,
          medium: that.mediumAlarm,
          high: that.highAlarm
        };

        messageActions.createAlarmSubscription(dataToSave).then(function () {
          $mdDialog.hide();
          layoutActions.hideLoader();
          refresh();
        });
      };

      /* eslint-enable */

      organizationActions.getAllSitesForExactUser().then(function (res) {
        that.siteList = res;
      });
    }
  }
})();
